import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Apps } from 'src/app/enum/enum';
import { AdminBreadcrumbsService } from '../admin-services/admin-breadcrumbs.service';
import { AnalyticsMenuService } from '../admin-services/analytics-menu.service';

@Component({
  selector: 'app-admin-analytics-view',
  template: `
    <div class="h-100">
      <app-admin-analytics-dashboard
        *ngIf="dashboardId"
        [dashboardId]="dashboardId"
      ></app-admin-analytics-dashboard>
      <div
        *ngIf="!dashboardId && !isLoading"
        class="alert alert-warning m-3 mb-0"
      >
        Dashboard not found or not configured.
      </div>
    </div>
  `
})
export class AnalyticsViewComponent implements OnInit, OnDestroy {
  dashboardId = '';
  isLoading = true;
  companyId = 0;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private analyticsMenuService: AnalyticsMenuService,
    private adminBreadcrumbs: AdminBreadcrumbsService
  ) {}

  ngOnInit(): void {
    this.companyId = Number(this.getUser()?.companyID) || 0;
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const mappingId = Number(params['mappingId']);
      if (!mappingId || !this.companyId) {
        this.dashboardId = '';
        this.isLoading = false;
        return;
      }

      this.analyticsMenuService
        .getMenuItems()
        .pipe(take(1))
        .subscribe((items) => {
          const menuName =
            items.find((item) => item.id === mappingId)?.menuName ||
            'Analytics';
          this.adminBreadcrumbs.updateBreadcrumbs([
            { crumbName: menuName, link: `/admin/home/analytics/${mappingId}` }
          ]);
        });

      this.dashboardId = '';
      this.isLoading = true;
      this.analyticsMenuService
        .getDashboardMappings(this.companyId, Apps.TPMPortal)
        .subscribe({
          next: (mappings) => {
            this.dashboardId =
              mappings.find((item) => item.id === mappingId)?.dashboardId || '';
            this.isLoading = false;
          },
          error: () => {
            this.dashboardId = '';
            this.isLoading = false;
          }
        });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getUser(): any {
    return JSON.parse(
      localStorage.getItem('userData') || localStorage.getItem('user') || '{}'
    );
  }
}
